export default "/assets/icons/cloud_off.svg"